<template>
  <div class="panel granary-right-panel">
    <bar-card :bg="'border-new'">
      <g-title :bg="'jxhsp'">机械化水平</g-title>
      <div class="content">
        <div class="jxh-box flex">
          <div class="jxh-zp flex">
            <img src="~images/granary/zzy/njzdl-bg.png" alt="" />
            <div class="zp">
              <p class="num">{{ nyjxzdl }}</p>
              <p class="zp-name">农业机械总动力</p>
              <p class="zp-dw">(万千瓦)</p>
            </div>
          </div>

          <div class="jxh-zp jxh-zp2 flex">
            <img src="~images/granary/zzy/zhjxhsp-bg.png" alt="" />
            <div class="zp">
              <p class="num">{{ znjzymj }}</p>
              <p class="zp-name">总农机作业面积</p>
              <p class="zp-dw">(千公顷)</p>
            </div>
          </div>
        </div>
        <div class="nyjx-box flex">
          <div class="jxh-item" v-for="(item, i) in mjList" :key="i">
            <p class="num">{{ item.num }}</p>
            <p class="fl-name">{{ item.name }}({{ item.unit }})</p>
          </div>
        </div>
        <div class="znj-box flex">
          <div class="jxh-item" v-for="(item, i) in spList" :key="i">
            <p class="num">{{ item.num }}</p>
            <p class="fl-name">{{ item.name }}({{ item.unit }})</p>
          </div>
        </div>
      </div>
    </bar-card>
  </div>
</template>

<script>
import gTitle from "../../components/gTitle";
//import { getSCREEN_ZZCK } from "@/api/nzw";
export default {
  components: { gTitle },
  data() {
    return {
      nyjxzdl: 208.19,
      znjzymj: 1040.6,
      mjList: [
        {
          name: "耕整地机械",
          num: 6.8,
          unit: "万台(套)"
        },
        {
          name: "排灌机械",
          num: 7.99,
          unit: "万台"
        },
        {
          name: "秸秆粉碎还田机",
          num: 24,
          unit: "台"
        },
        {
          name: "植保无人机",
          num: 38,
          unit: "架"
        },
        {
          name: "收获机械",
          num: 10.08,
          unit: "万台"
        },
        {
          name: "水产机械",
          num: 9.26,
          unit: "万台"
        }
      ],
      spList: [
        {
          name: "机耕面积",
          num: 387.92,
          unit: "千公顷"
        },
        {
          name: "机播面积",
          num: 35.25,
          unit: "千公顷"
        },
        {
          name: "机电灌溉面积",
          num: 157.85,
          unit: "千公顷"
        },
        {
          name: "机械植保面积",
          num: 235.85,
          unit: "千公顷"
        },
        {
          name: "机收面积",
          num: 223.73,
          unit: "千公顷"
        }
      ]
    };
  },
  mounted() {
    // this.getData();
  },
  methods: {
    getData() {}
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'

.panel
  // height calc(42% - 8px)
  height calc(65% - 0px)
  font-size .06rem

.content
  height calc(100% - .2rem)
  width calc(100% - 20px)
  padding 0 10px
  position relative
  .jxh-box
    width 100%
    padding 10px 0 0
    justify-content space-around
    .jxh-zp
      // width 185px
      // height 156px
      width 33%
      height 130px
      // background url("~images/granary/zzy/njzdl-bg.png") no-repeat center
      // background-size 100% 100%
      color #fff
      position relative
      >img
        position absolute
        left 2%
        top 2%
        width 96%
        height 96%
        animation rotate 5s linear infinite
      .zp
        position absolute
        left 50%
        top 50%
        transform translate(-50%, -50%)
        width 100%
        p
          text-align center
        .num
          font-size 22px
          color #0ff
        .zp-name
          margin-top 5px
          font-size 12px
        .zp-dw
          font-size 10px
    .jxh-zp2
      // background url("~images/granary/zzy/zhjxhsp-bg.png") no-repeat center
      // background-size 100% 100%
      .zp
        .num
          color #ff9f00
    // .jxh-item
    //   // width 154px
    //   // height 82px
    //   width 48%
    //   height 90px
    //   box-sizing border-box
    //   background url("~images/granary/zzy/mj-bg.png") no-repeat center
    //   background-size 100% 100%
    //   // padding 18px 0 0 22px
    //   padding 10px 0 0 10px
    //   // margin 30px auto 0
    //   margin 10px 0
    //   .num
    //     color #00ffff
    //     font-size 18px
    //   .fl-name
    //     color #fff
    //     font-size 14px
    //     margin-top 12px
    // .jxh-left
    //   width 66%
    //   .jxh-item-box
    //     justify-content space-between
    //     flex-wrap wrap
    // .jxh-right
    //   width 32%
    //   margin-left 2%
    //   .jxh-item
    //     width 100%
    //     background url("~images/granary/zzy/percent-bg.png") no-repeat center
    //     background-size 100% 100%
    //     .num
    //       color #ff9f00

  .jxh-item
    // width 154px
    // height 82px
    width calc((100% - 20px) / 3)
    height calc((100% - 40px) / 2)
    // height 90px
    padding 10px 0 0 10px
    margin 10px 10px 10px 0
    box-sizing border-box
    background url("~images/granary/zzy/mj-bg.png") no-repeat center
    background-size 100% 100%
    .num
      color #00ffff
      font-size 18px
    .fl-name
      color #fff
      font-size 14px
      margin-top 12px
    &:nth-of-type(3n)
      margin-right 0

  .nyjx-box
    flex-wrap wrap
    height calc((100% - 140px) / 2)
  .znj-box
    flex-wrap wrap
    height calc((100% - 140px) / 2)
    .jxh-item
        // width 100%
        background url("~images/granary/zzy/percent-bg.png") no-repeat center
        background-size 100% 100%
        .num
          color #ff9f00

@keyframes rotate
  0%
    transform rotate(0deg)
  100%
    transform rotate(360deg)
</style>
